<div class="container" [ngClass]="classes()" (click)="focused()">
    <input type="text"
           aria-label="Hours"
           #inputHour
           placeholder="00"
           (blur)="blurHour()">
    <span class="seperator">:</span>
    <input type="text"
           aria-label="Minutes"
           #inputMinute
           placeholder="00"
           (blur)="blurMinute()">

    <span class="placeholder" *ngIf="showPlaceholder">{{placeholder}}</span>
</div>


// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/time-input/time-input.component.html